import { queryBot2 } from 'boot/axios';

export async function saveProjectDocumentUrl (item) {
    const { id, value } = item;
    if (!id) {
        return;
    }
    await queryBot2('saveProjectDocumentUrl', { value, id }).then(() => {
        console.log('upd');
    });
}

export async function saveProjectDocumentParams (value) {
    const { projectId, documentId, url } = value;
    return queryBot2('saveProjectDocumentParams', { projectId, documentId, url }).then(() => true);
}

export async function saveProjectDocument () {
    return queryBot2('saveProjectDocument').then(() => true);
}

export async function savePortfolioDocumentItem (item) {
    const { id, key, value } = item;
    if (!key || !id) {
        return;
    }
    // values of key: open_at, document, portfolio
    await queryBot2(`savePortfolioDocument-${key}`, { value, id }).then(() => {
        console.log('upd');
    });
}

export async function savePortfolioDocument () {
    return queryBot2('savePortfolioDocument').then(() => true);
}

export async function saveDocumentTitle (item) {
    const { id, value } = item;
    if (!id) {
        return;
    }
    await queryBot2('saveDocumentTitle', { value, id }).then(() => {
        console.log('upd');
    });
}

export async function saveDocumentDescription (item) {
    const { id, value } = item;
    if (!id) {
        return;
    }
    await queryBot2('saveDocumentDescription', { value, id }).then(() => {
        console.log('upd');
    });
}

export async function saveDocument () {
    return queryBot2('saveDocument').then(() => true);
}

export default saveDocument;
